import flatpickr from "flatpickr";
import {German} from "flatpickr/dist/l10n/de";
import {sendBasketForm} from "./basket";
import {getOptionsFromJsonString} from "./utilities/options";

function disableWeekend(date) {
    return (date.getDay() === 0 || date.getDay() === 6);
}

function disableSunday(date) {
    return (date.getDay() === 0);
}

function updateDatepickerFormGroup(picker){
    let inputGroup = picker.closest(".inputGroup");
    if(inputGroup){
        if(picker.value) {
            inputGroup.classList.remove("is-inactive");
        }else{
            inputGroup.classList.add("is-inactive");
        }
    }
}

function handleClearButton(flatpickr){
    let inputDate = flatpickr.input;
    let inputGroup = inputDate.closest(".inputGroup");
    if(inputGroup){
        let deleteButton = inputGroup.querySelector(".js-datepicker-clear");
        if(deleteButton){
            deleteButton.addEventListener("click",function (){
                flatpickr.clear();
                updateDatepickerFormGroup(inputDate);
            });
        }else{
            console.error("cannot find datepicker clear button");
        }
    }
}

export function initDatepicker(query = document.querySelectorAll('.js-datepicker'), onValueUpdate = function () {
}) {
    let locale = false;

    if(GLOBALS){
        if(GLOBALS.config.languageCode === "de"){
            locale = German;
        }
    }
    for(let picker of query){
        let options = getOptionsFromJsonString(picker.dataset.options, {
            hideWeekend: false,
            hideSunday: false
        });
        let min = "today";
        let minDate = picker.getAttribute("min");
        if (minDate !== "today") {
            min = minDate;
        }

        updateDatepickerFormGroup(picker);

        if(options.hideSunday){
            flatpickr(picker, {
                "locale": locale,
                altInput: true,
                altFormat: "d.m.Y",
                minDate: min,
                dateFormat: "Y-m-d",
                onReady: function(selectedDates, dateStr, instance) {
                    handleClearButton(instance);
                },
                onValueUpdate: function(){
                    updateDatepickerFormGroup(picker);
                    onValueUpdate();
                },
                disable: [disableSunday]
            });
            return;
        }

        if(options.hideWeekend){
            flatpickr(picker, {
                "locale": locale,
                altInput: true,
                altFormat: "d.m.Y",
                minDate: min,
                dateFormat: "Y-m-d",
                onReady: function(selectedDates, dateStr, instance) {
                    handleClearButton(instance);
                },
                onValueUpdate: function(){
                    updateDatepickerFormGroup(picker);
                    onValueUpdate();
                },
                disable: [disableWeekend]
            });
            return;
        }

        flatpickr(picker, {
            "locale": locale,
            altInput: true,
            altFormat: "d.m.Y",
            minDate: min,
            dateFormat: "Y-m-d",
            onReady: function(selectedDates, dateStr, instance) {
                handleClearButton(instance);
            },
            onValueUpdate:function(){
                updateDatepickerFormGroup(picker);
                onValueUpdate();
            }
        });
    }
}


export function initDatepickerWithAjax(query = document.querySelectorAll('.js-datepicker-ajax'), onValueUpdate = () => {}) {


    let locale = false;

    if (GLOBALS?.config?.languageCode === "de") {
        locale = German;
    }

    for (const picker of query) {

        // 1. Suche das übergeordnete Wrapper-Element mit der basket-id
        const basketWrapper = picker.closest('.contentTabs__basketWrapper');
        const basketId = basketWrapper?.dataset?.basketId || null;

        // 2. Falls vorhanden, schreibe basket_id in das data-options JSON
        if (basketId) {
            try {
                const optionsData = JSON.parse(picker.dataset.options);
                optionsData.basket_id = basketId;
                picker.dataset.options = JSON.stringify(optionsData);
            } catch (e) {
                console.error("Fehler beim Parsen von data-options:", e);
            }
        }

        // 3. Jetzt wie gewohnt die Optionen laden
        const options = getOptionsFromJsonString(picker.dataset.options, {
            hideWeekend: false,
            hideSunday: false
        });


        //  Ungültiges Datum wie "0000-00-00" entfernen
        if (picker.value === "0000-00-00") {
            picker.value = "";
        }




        let min = "today";
        const minDate = picker.getAttribute("min");
        if (minDate !== "today") {
            min = minDate;
        }

        updateDatepickerFormGroup(picker);


        const triggerBasketRefreshWithDate = (dateStr) => {
            if (!dateStr || dateStr === "0000-00-00") {
                return;
            }
            const form = picker.closest(".js-itemBasketList");
            const basketView = document.getElementById("userBasket");
            if (form && basketView) {
                // Warenkorb-Seite: Basket-Form per AJAX refreshen
                sendBasketForm(form, basketView);
            }
            // Checkout-Kontext: Submit-Handler übernimmt das (siehe unten)
        };

        // Checkout-Kontext: js-formSubmitClick ruft form.submit() auf, das kein submit-Event feuert.
        // Daher direkt den Speichern-Button abfangen: erst Datum per AJAX speichern,
        // dann GET-Reload damit Preise mit neuem Datum korrekt berechnet werden.
        const checkoutForm = picker.closest("form:not(.js-itemBasketList)");
        if (checkoutForm && !picker.closest(".js-itemBasketList")) {
            const saveBtn = checkoutForm.querySelector(".js-formSubmitClick");
            if (saveBtn) {
                saveBtn.addEventListener("click", (e) => {
                    const dateStr = picker.value;
                    if (!dateStr || dateStr === "0000-00-00") return;
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    // Form per fetch POSTen (Datum wird serverseitig gespeichert),
                    // danach GET-Reload damit Preise mit neuem Datum korrekt berechnet werden.
                    fetch(checkoutForm.action, { method: 'POST', body: new FormData(checkoutForm) })
                        .finally(() => { window.location.href = window.location.pathname; });
                }, true); // capture phase, vor js-formSubmitClick
            }
        }

        let isReady = false;

        const commonOptions = {
            locale,
            altInput: true,
            altFormat: "d.m.Y",
            minDate: min,
            dateFormat: "Y-m-d",
            disableMobile: true,
            onReady(selectedDates, dateStr, instance) {
                //handleClearButton(instance);

                const hiddenInput = picker; // dein hidden Input
                const visibleInput = instance.altInput; // das sichtbare Flatpickr-Feld

                // Wenn hidden Value vorhanden, aber sichtbares Feld leer
                if (hiddenInput.value && !visibleInput.value) {
                    // Prüfen, ob das Format d.m.Y ist
                    const parts = hiddenInput.value.split('.');
                    if (parts.length === 3) {
                        const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`; // Y-m-d
                        instance.setDate(formattedDate, true); // true = onChange triggern
                    } else {
                        // Fallback: einfach Value übernehmen
                        instance.setDate(hiddenInput.value, true);
                    }
                }

                isReady = true;
            },
            onValueUpdate(selectedDates, dateStr, instance) {
                updateDatepickerFormGroup(picker);
                onValueUpdate();

                if (isReady) {
                    triggerBasketRefreshWithDate(dateStr);
                }
            }
        };

        if (options.hideSunday) {
            flatpickr(picker, {
                ...commonOptions,
                disable: [disableSunday]
            });
        } else if (options.hideWeekend) {
            flatpickr(picker, {
                ...commonOptions,
                disable: [disableWeekend]
            });
        } else {
            flatpickr(picker, commonOptions);
        }
    }
}
